import React, { useEffect, useState } from 'react';
import { useStyles } from "./Footer.css";
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getManifParams } from '../../actions/manif';
import { AppBar, Toolbar, Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import ChatPopper from '../chat/ChatPopper';
import rest from '../../rest';
import LienAvecVerification from './LienAvecVerification';
import { getThemeStyles } from './themeUtils';


const Footer = (props) => {

    const classes = useStyles();
    const manifParams = useSelector(state => state.manif);
    const [showMessage, setShowMessage] = useState(false);
    const [nbMessage, setNbMessage] = useState(0);
    const [reloadNbMsg, setReloadNbMsg] = useState(false);
    const [textes, setTextes] = useState([]);
    const currentUser = useSelector((state) => state.user);
  
    const theme = useTheme();
    const querysmDown = useMediaQuery(theme.breakpoints.down("sm"));

    const fetchNotReadMessages = () => {
        rest.get('/benevols/chat/notRead.json')
            .then((response) => {
                setNbMessage(response.data.nbMessage);
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    // Gérer l'erreur 401 ici, par exemple en ignorant l'erreur
                    console.log('Utilisateur non connecté, impossible de récupérer les messages.');
                } else {
                    // Gérer les autres erreurs
                    console.error('Error fetching messages', error);
                }
            });
    };

    useEffect(() => {
        fetchNotReadMessages();

        if (currentUser.User.User_Chef) {
            setShowMessage(true);
        } else {
            rest.get('/benevols/chat/showChat.json')
                .then((response) => {
                    setShowMessage(response.data.hasTranches);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 401) {
                        // Gérer l'erreur 401 ici
                        console.log('Utilisateur non connecté, impossible de vérifier la visibilité du chat.');
                    } else {
                        // Gérer les autres erreurs
                        console.error('Error fetching chat visibility', error);
                    }
                });
        }
    }, [currentUser]);

    useEffect(() => {
        fetchNotReadMessages();
    }, [reloadNbMsg]);


    useEffect(() => {
        if (showMessage) {
            const intervalId = setInterval(() => {
                setReloadNbMsg(prev => !prev);
            }, 60000);

            // Retourne une fonction de nettoyage pour clearInterval
            return () => clearInterval(intervalId);
        }
    }, [setReloadNbMsg, showMessage]);


    let classesSelected = getThemeStyles(props.manif?.manifParams?.Theme);

    useEffect(() => {
        // Liste des propriétés à gérer
        const properties = [
            { name: 'mentionLegale', label: 'Mentions Légales', content: '' },
            { name: 'noticeDeConfidentialite', label: 'Notice de confidentialité', content: '' },
            { name: 'CharteBenevole', label: 'Charte des bénévoles', content: '' }];

        // Mise à jour des propriétés dans l'état
        properties.forEach(prop => {
            prop.content = manifParams?.manifParams?.[prop.name] || '';
        });
        setTextes(properties);
    }, [manifParams]);

    return (
        <AppBar position="fixed" color="primary" className={classesSelected.footerBar}>
            <Toolbar className={classes.toolBarClass}>
                <Grid container alignItems="flex-start" spacing={2}>
                    <Grid item sx={12} md={8} style={{ textAlign: "left" }}>
                        <Typography className={classes.alignTextLeft} variant="caption" >{new Date().getFullYear()} © Lysoft SA</Typography>
                        {textes.map((prop, index) => (
                            prop.content && <LienAvecVerification
                                key={index}
                                url={prop.content}
                                label={prop.label}
                                fallbackUrl={'/gtexte.html?titre=' + prop.name}
                                classes={classes}
                                target="_blank"
                            />
                        ))}
                        {querysmDown && ` - version : ${manifParams.manifParams.versionNum}`}
                    </Grid>
                    {!querysmDown && <Grid item sx={0} md={4} style={{ textAlign: "right" }}>
                        <Typography className={classes.alignTextRight} variant="caption" >{manifParams.manifParams.versionNum}</Typography>
                    </Grid>}
                </Grid>
            </Toolbar>
            {showMessage && <ChatPopper nbMessage={nbMessage} setReloadNbMsg={setReloadNbMsg} reloadNbMsg={reloadNbMsg} />}
        </AppBar>
    )
}

const mapStateToProps = (state) => {
    return {
        manif: state.manif,
        user: state.user,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ getManifParams }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer)